export const CoreComponentsToSingular = {
	"Areas of Responsibility": "Area of Responsibility",
	"Objectives": "Objective",
	"Actions": "Action",
	"Supporting Assets and Resources": "Supporting Asset/Resource",
	"Reliability Indicators": "Reliability Indicator",
	"Risk Factors": "Risk Factor"
}